import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"
import _imports_0 from '../../assets/svgs/share.svg'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  class: "h-5 w-5",
  fill: "none",
  style: {"color":"6e7191"},
  viewBox: "0 0 24 24",
  stroke: "currentColor"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M8.684 13.342C8.886 12.938 9 12.482 9 12c0-.482-.114-.938-.316-1.342m0 2.684a3 3 0 110-2.684m0 2.684l6.632 3.316m-6.632-6l6.632-3.316m0 0a3 3 0 105.367-2.684 3 3 0 00-5.367 2.684zm0 9.316a3 3 0 105.368 2.684 3 3 0 00-5.368-2.684z"
  })
], -1)
const _hoisted_2 = [
  _hoisted_1
]
const _hoisted_3 = {
  key: 0,
  class: "absolute lg:right-0 md:right-0 left-0 top-auto mt-2 w-52 rounded-xl shadow-xl text-sm overflow-hidden z-20"
}
const _hoisted_4 = {
  class: "rounded-md bg-white shadow-xs w-full px-2 py-1",
  role: "menu",
  "aria-orientation": "vertical",
  "aria-labelledby": "options-menu"
}
const _hoisted_5 = { class: "flex flex-col mt-4" }
const _hoisted_6 = ["href"]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-row items-center" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }),
  /*#__PURE__*/_createElementVNode("span", { class: "font-semibold ml-4" }, "View candidate")
], -1)
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "h-0.5 bg-gray-200 mx-4 my-2" }, null, -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-row items-center" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "h-6 w-6",
    style: {"color":"6e7191"},
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2",
      d: "M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z"
    })
  ]),
  /*#__PURE__*/_createElementVNode("span", { class: "font-semibold ml-4 text-xs" }, "Copy to clipboard")
], -1)
const _hoisted_11 = [
  _hoisted_10
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_click_away = _resolveDirective("click-away")!

  return _withDirectives((_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("button", {
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isMenuOpen = !_ctx.isMenuOpen)),
      type: "button",
      class: "select-none py-2 px-2 hover:bg-gray-100 rounded-full"
    }, _hoisted_2),
    _createVNode(_Transition, {
      "enter-active-class": "transition ease-out duration-200",
      "enter-class": "transform opacity-0 scale-95",
      "enter-to-class": "transform opacity-100 scale-100",
      "leave-active-class": "transition ease-in duration-75",
      "leave-class": "transform opacity-100 scale-100",
      "leave-to-class": "transform opacity-0 scale-95"
    }, {
      default: _withCtx(() => [
        (_ctx.isMenuOpen)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("a", {
                    href: `${_ctx.openCandidateDetail}`,
                    target: "_blank",
                    class: "rounded p-4 hover:bg-background"
                  }, _hoisted_8, 8, _hoisted_6),
                  _hoisted_9,
                  _createElementVNode("button", {
                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.copy && _ctx.copy(...args))),
                    class: "rounded p-4 hover:bg-background"
                  }, _hoisted_11)
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ])), [
    [_directive_click_away, _ctx.closeMenu]
  ])
}